/* eslint-disable no-use-before-define */
import React from 'react'
import { Media } from 'components/core/BreakpointMedia'
import MobileStores from './mobile'
import DesktopStores from './DesktopStores'
import StoreSkeleton from './Skeleton'

const Stores = ({ stores, storeToShow, setStoreToShow, isLoading }) => {
  if (isLoading || stores?.length === 0) {
    return <StoreSkeleton />
  }

  return (
    <>
      <Media greaterThanOrEqual="medium">
        {stores?.length > 0 && (
          <DesktopStores
            stores={stores}
            storeToShow={storeToShow}
            setStoreToShow={setStoreToShow}
          />
        )}
      </Media>
      <Media lessThan="medium">
        {stores?.length > 0 && (
          <MobileStores stores={stores} storeToShow={storeToShow} setStoreToShow={setStoreToShow} />
        )}
      </Media>
    </>
  )
}

export default Stores
